import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { ControllerUpdateType, ControllerVersion } from 'lavva.exalushome/build/js/Services/Updates/IUpdateInfo';
import ArrowButton from '../../../../../../components/arrow-button';
import { Dialog } from '../../../../../../components/dialog/base';
import TextInfo from '../../../../../../components/text-info';
import './controller-version-button.scss';

type ControllerVersionButtonProps = {
  show: boolean;
  setShow: Dispatch<SetStateAction<boolean>>;
  controllerVersion: ControllerVersion[];
  getCurrentControllerVersion: () => void;
};

export const ControllerVersionButton: React.FC<ControllerVersionButtonProps> = ({
  show,
  setShow,
  controllerVersion,
  getCurrentControllerVersion,
}) => {
  const { t } = useTranslation('device-info');
  const { t: ti } = useTranslation('installation');

  return (
    <>
      <ArrowButton title={ti('exalus.controllerVersion')} className="m-b-24" onClick={getCurrentControllerVersion} />
      <Dialog
        show={show}
        setShow={setShow}
        title={t('exalus.params.Version.currentVersion')}
        closeBtn
        className="controller-version-dialog"
      >
        <div className="controller-version-dialog--content">
          {controllerVersion.map((version: ControllerVersion) => (
            <div key={version.Resource} className="version-container">
              <h3>{`${t(
                `exalus.params.Version.${
                  version.Type === ControllerUpdateType.SoftwareUpdate ? 'SoftwareUpdate' : 'RadioFirmware'
                }`,
              )} ${version.Type !== ControllerUpdateType.SoftwareUpdate ? version.Resource : ''}`}</h3>
              <div className="version-values">
                <TextInfo
                  value={version.Version}
                  label={`${t('exalus.params.Version.currentVersion')}:`}
                  big
                  className="m-b-8"
                />
                <TextInfo
                  value={version.Type !== null ? t(`exalus.params.Version.${ControllerUpdateType[version.Type]}`) : '-'}
                  label={`${t('exalus.params.Version.type')}:`}
                  big
                  className="m-b-8"
                />
                <hr className="m-t-24 m-b-24" />
              </div>
            </div>
          ))}
        </div>
      </Dialog>
    </>
  );
};
